export class UserProfile {
        public ReducedName: string;
        public PathFoto: string;
        public Categoria: string;
}

export class User extends UserProfile {
        public Nome: string;
        public Login: string;
        public Guid: string;
        public TipoAssociacao: string;
        public InscricaoPaga: boolean;
        public TipoAssociacaoId: number;
        public CategoriaId: number;
        public SgunId: number;
        public IsAdimplente: boolean;
        public AnosParticipados: string;
        public AnoCongressoLiberado: number;
        public Facebook: string;
        public Twitter: string;
        public Linkedin: string;
        public Lattes: string;
        public PermiteCalendario: boolean;
        public NotificacaoAula: number;
        public DeviceToken: string;
        public isLogged: boolean;
        public Prescritor: boolean;
        public Ingresso: any;
        public PermiteEmailMarketing: boolean | null;
}

export class UserDesc extends UserProfile {
        public ReducedName: string;
        public Categoria: string;

}



// WEBPACK FOOTER //
// ./src/models/user.model.ts